import { useContext, useMemo } from 'react';
import { BookingContext } from 'components/Booking-new/providers/booking';
import { setActiveStep, setNextStep, setPrevStep } from 'components/Booking-new/actions';
import { getAllSteps, getNextStep, getPrevStep } from 'components/Booking-new/utils/state';
import navigationServiceReload from '../utils/steps/reschedule/navigationServiceReload';

const isFunction = functionToCheck => {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
};

function useSelector(selectorFunction) {
  const [state] = useContext(BookingContext);
  const results = useMemo(() => (isFunction(selectorFunction) ? selectorFunction(state) : null), [state]);

  return {
    state,
    results,
  };
}

function useDispatch() {
  const [, dispatch] = useContext(BookingContext);

  return dispatch;
}

function useSteps() {
  const [state, dispatch] = useContext(BookingContext);
  const allSteps = getAllSteps(state);
  const allStepsCount = allSteps.length;

  const activeStepIndex = useMemo(() => state?.activeStep, [state?.activeStep]);
  const activeStep = useMemo(() => allSteps?.[state?.activeStep], [allSteps, state?.activeStep]);
  const activeStepType = activeStep?.type;

  const [isNextStep, nextStep] = getNextStep(activeStepIndex, allSteps);
  const [isPrevStep, prevStep] = getPrevStep(activeStepIndex, allSteps);

  const goToNextStep = async () => {
    dispatch(setNextStep(nextStep));
    if (activeStep.type === 'ContentfulBookingStepReschedule')
      await navigationServiceReload(state.userData.ContentfulBookingStepReschedule.service.service);
  };
  const goToPrevStep = () => dispatch(setPrevStep(prevStep));
  const goToStep = stepIndex => dispatch(setActiveStep(stepIndex));

  const goToStepType = stepType => {
    const stepIndex = allSteps.findIndex(step => step?.type === stepType);
    if (stepIndex !== -1) goToStep(stepIndex);
  };

  return {
    activeStepIndex,
    activeStep,
    activeStepType,
    allSteps,
    allStepsCount,
    isNextStep,
    isPrevStep,
    goToNextStep,
    goToPrevStep,
    goToStep,
    goToStepType,
  };
}

export { useSteps, useDispatch };

export default useSelector;
